import React from "react";

import styled from "styled-components";

const Container = styled.div`
  max-width: 800px;
  margin: 25px auto;
  padding: 20px;
`;

const Heading1 = styled.h1`
  font-size: 2rem;
  color: #007bff;
  margin-bottom: 20px;
`;

const Heading2 = styled.h2`
  font-size: 1.5rem;
  color: #007bff;
  margin-top: 20px;
`;

const Heading3 = styled.h3`
  font-size: 1.2rem;
  color: #007bff;
  margin-top: 15px;
`;

const Paragraph = styled.p`
  margin-bottom: 15px;
`;

const UnorderedList = styled.ul`
  padding-left: 20px;
`;

const Anchor = styled.a`
  color: #007bff;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const Terms = () => {
  return (
    <Container>
      <Heading1>Website Terms and Conditions</Heading1>
      <Paragraph>Last updated: November 17, 2023</Paragraph>
      <Paragraph>
        Please read these terms and conditions carefully before using Our
        Service.
      </Paragraph>
      <Heading2>Interpretation and Definitions</Heading2>
      <h3>Interpretation</h3>
      <Paragraph>
        The words of which the initial letter is capitalized have meanings
        defined under the following conditions. The following definitions shall
        have the same meaning regardless of whether they appear in singular or
        in plural.
      </Paragraph>
      <h3>Definitions</h3>
      <Paragraph>For the purposes of these Terms and Conditions:</Paragraph>
      <ul>
        <li>
          <Paragraph>
            <strong>Affiliate</strong> means an entity that controls, is
            controlled by or is under common control with a party, where
            &quot;control&quot; means ownership of 50% or more of the shares,
            equity interest or other securities entitled to vote for election of
            directors or other managing authority.
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            <strong>Country</strong> refers to: the Republic of South Africa
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            <strong>Company</strong> (referred to as either &quot;the
            Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in
            this Agreement) refers to Simandlovu Trading CC, 6-8 Cobbleset Lane,
            New Germany Pinetown Durban.
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            <strong>Device</strong> means any device that can access the Service
            such as a computer, a cellphone or a digital tablet.
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            <strong>Service</strong> refers to the Website.
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            <strong>Terms and Conditions</strong> (also referred as
            &quot;Terms&quot;) mean these Terms and Conditions that form the
            entire agreement between You and the Company regarding the use of
            the Service.
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            <strong>Website</strong> refers to simandlovu Trading, accessible
            from{" "}
            <a
              href="https://simandlovu.com"
              rel="external nofollow noopener"
              target="_blank"
            >
              https://simandlovu.com
            </a>
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            <strong>You</strong> means the individual accessing or using the
            Service, or the company, or other legal entity on behalf of which
            such individual is accessing or using the Service, as applicable.
          </Paragraph>
        </li>
      </ul>
      <Heading2>Acknowledgment</Heading2>
      <Paragraph>
        These are the Terms and Conditions governing the use of this Service and
        the agreement that operates between You and the Company. These Terms and
        Conditions set out the rights and obligations of all users regarding the
        use of the Service.
      </Paragraph>
      <Paragraph>
        Your access to and use of the Service is conditioned on Your acceptance
        of and compliance with these Terms and Conditions. These Terms and
        Conditions apply to all visitors, users and others who access or use the
        Service.
      </Paragraph>
      <Paragraph>
        By accessing or using the Service You agree to be bound by these Terms
        and Conditions. If You disagree with any part of these Terms and
        Conditions then You may not access the Service.
      </Paragraph>
      <Paragraph>
        Your access to and use of the Service is also conditioned on Your
        acceptance of and compliance with the Privacy Policy of the Company. Our
        Privacy Policy describes Our policies and procedures on the collection,
        use and disclosure of Your personal information when You use the
        Application or the Website and tells You about Your privacy rights and
        how the law protects You. Please read Our Privacy Policy carefully
        before using Our Service.
      </Paragraph>
      <Heading2>Links to Other Websites</Heading2>
      <Paragraph>
        Our Service may contain links to third-party web sites or services that
        are not owned or controlled by the Company.
      </Paragraph>
      <Paragraph>
        The Company has no control over, and assumes no responsibility for, the
        content, privacy policies, or practices of any third party web sites or
        services. You further acknowledge and agree that the Company shall not
        be responsible or liable, directly or indirectly, for any damage or loss
        caused or alleged to be caused by or in connection with the use of or
        reliance on any such content, goods or services available on or through
        any such web sites or services.
      </Paragraph>
      <Paragraph>
        We strongly advise You to read the terms and conditions and privacy
        policies of any third-party web sites or services that You visit.
      </Paragraph>
      <Heading2>Use of the Website</Heading2>
      <Paragraph>
        The contents of this Website, including any content, information,
        software, icons, text, links, graphics, layouts, images, sound clips,
        trade names, logos, trademarks, and service marks, are protected by law
        and are owned or licensed to the company, including but not limited to
        copyright and trade mark law. You are not provided or conferred with any
        license or right in any of these contents. Any unlawful use,
        distribution, or replication of the aforementioned contents is strictly
        banned. By using this Website, you agree that you will not use any
        device, program, or other instrumentality to interfere with or attempt
        to interfere with the Website's normal operation. and that you will not
        take any activity that places an unfair or disproportionately
        significant demand on our system. Furthermore, you agree not to use any
        robot, spider, other automatic device, or manual process to monitor or
        copy the pages of the Website or the content contained herein without
        the prior written consent of an authorized Company representative (such
        consent is deemed given for standard search engine technology used by
        Internet search websites to direct Internet users to this Website). You
        may not use the Website to distribute material that is defamatory,
        offensive, or illegal, or that contains hate speech.
      </Paragraph>
      <Heading2>Termination</Heading2>
      <Paragraph>
        We may terminate or suspend Your access immediately, without prior
        notice or liability, for any reason whatsoever, including without
        limitation if You breach these Terms and Conditions.
      </Paragraph>
      <Paragraph>
        Upon termination, Your right to use the Service will cease immediately.
      </Paragraph>
      <Heading2>Limitation of Liability</Heading2>

      <Paragraph>
        To the maximum extent permitted by applicable law, in no event shall the
        Company or its suppliers be liable for any special, incidental,
        indirect, or consequential damages whatsoever (including, but not
        limited to, damages for loss of profits, loss of data or other
        information, for business interruption, for personal injury, loss of
        privacy arising out of or in any way related to the use of or inability
        to use the Service, third-party software and/or third-party hardware
        used with the Service, or otherwise in connection with any provision of
        this Terms), even if the Company or any supplier has been advised of the
        possibility of such damages and even if the remedy fails of its
        essential purpose.
      </Paragraph>
      <Heading2>Disclaimer</Heading2>
      <Paragraph>
        The Service is provided to You &quot;AS IS&quot; and &quot;AS
        AVAILABLE&quot; and with all faults and defects without warranty of any
        kind. To the maximum extent permitted under applicable law, the Company,
        on its own behalf and on behalf of its Affiliates and its and their
        respective licensors and service providers, expressly disclaims all
        warranties, whether express, implied, statutory or otherwise, with
        respect to the Service, including all implied warranties of
        merchantability, fitness for a particular purpose, title and
        non-infringement, and warranties that may arise out of course of
        dealing, course of performance, usage or trade practice. Without
        limitation to the foregoing, the Company provides no warranty or
        undertaking, and makes no representation of any kind that the Service
        will meet Your requirements, achieve any intended results, be compatible
        or work with any other software, applications, systems or services,
        operate without interruption, meet any performance or reliability
        standards or be error free or that any errors or defects can or will be
        corrected.
      </Paragraph>
      <Paragraph>
        Without limiting the foregoing, neither the Company nor any of the
        company's provider makes any representation or warranty of any kind,
        express or implied: (i) as to the operation or availability of the
        Service, or the information, content, and materials or products included
        thereon; (ii) that the Service will be uninterrupted or error-free;
        (iii) as to the accuracy, reliability, or currency of any information or
        content provided through the Service; or (iv) that the Service, its
        servers, the content, or e-mails sent from or on behalf of the Company
        are free of viruses, scripts, trojan horses, worms, malware, timebombs
        or other harmful components.
      </Paragraph>
      <Heading2>Governing Law</Heading2>
      <Paragraph>
        The laws of the Country, excluding its conflicts of law rules, shall
        govern this Terms and Your use of the Service. Your use of the
        Application will constitute your consent and submission to the
        jurisdiction of the South African courts regarding all proceedings,
        transactions, applications or the like instituted by either party
        against the other, arising from any of the terms and conditions
        pertaining to such services.
      </Paragraph>
      <Heading2>Disputes Resolution</Heading2>
      <Paragraph>
        If You have any concern or dispute about the Service, You agree to first
        try to resolve the dispute informally by contacting the Company.
      </Paragraph>
      <Heading2>Severability and Waiver</Heading2>
      <h3>Severability</h3>
      <Paragraph>
        If any provision of these Terms is held to be unenforceable or invalid,
        such provision will be changed and interpreted to accomplish the
        objectives of such provision to the greatest extent possible under
        applicable law and the remaining provisions will continue in full force
        and effect.
      </Paragraph>
      <h3>Waiver</h3>
      <Paragraph>
        Except as provided herein, the failure to exercise a right or to require
        performance of an obligation under these Terms shall not effect a
        party's ability to exercise such right or require such performance at
        any time thereafter nor shall the waiver of a breach constitute a waiver
        of any subsequent breach.
      </Paragraph>
      <Heading2>Changes to These Terms and Conditions</Heading2>
      <Paragraph>
        We reserve the right, at Our sole discretion, to modify or replace these
        Terms at any time. If a revision is material We will make reasonable
        efforts to provide at least 30 days' notice prior to any new terms
        taking effect. What constitutes a material change will be determined at
        Our sole discretion.
      </Paragraph>
      <Paragraph>
        By continuing to access or use Our Service after those revisions become
        effective, You agree to be bound by the revised terms. If You do not
        agree to the new terms, in whole or in part, please stop using the
        website and the Service.
      </Paragraph>
      <Heading2>Contact Us</Heading2>
      <Paragraph>
        If you have any questions about these Terms and Conditions, You can
        contact us:
      </Paragraph>
      <ul>
        <li>
          <Paragraph>By email: simandlovutrading@gmail.com</Paragraph>
        </li>
        <li>
          <Paragraph>
            By visiting this page on our website:{" "}
            <a
              href="http://simandlovu.com/contact"
              rel="external nofollow noopener"
              target="_blank"
            >
              http://simandlovu.com/contact
            </a>
          </Paragraph>
        </li>
        <li>
          <Paragraph>By phone number: 072 392 2392</Paragraph>
        </li>
      </ul>
    </Container>
  );
};

export default Terms;
